export const getAllEditionsFragment = () => `editionId
year`
